import { Component, OnInit, Input, Output, EventEmitter, ElementRef, Renderer2, IterableDiffers, IterableDiffer, DoCheck } from '@angular/core';
import { Filter } from '../../../../models/filter.model';
import { Column } from '../../../../models/column.model';
import { orderPreviusList, sortListByOrder, setOrderToList } from 'src/app/reports/helpers/column.helper';

@Component({
  selector: 'app-order-changer',
  templateUrl: './order-changer.component.html',
  styleUrls: ['./order-changer.component.scss']
})
export class OrderChangerComponent implements OnInit, DoCheck {

  @Input() item: Column | Filter;
  @Input() list: Array<Column | Filter> = [];

  @Input() disabled: boolean;

  @Output() orderChange: EventEmitter<Column | Filter> = new EventEmitter<Column | Filter>();
  @Output() listChange: EventEmitter<Array<Column | Filter>> = new EventEmitter<Array<Column | Filter>>();

  showActions = false;
  differ: IterableDiffer<any>;

  constructor(private elm: ElementRef,
    private renderer: Renderer2,
    private differs: IterableDiffers) {
    this.differ = this.differs.find(this.list).create(null);
  }

  //#region Interface Implementations

  ngOnInit() {

    if (this.elm && this.elm.nativeElement) {
      const elm = this.elm.nativeElement,
        parent = elm.parentElement;

      if (parent) {
        this.renderer.listen(parent, 'mouseover', (event) => {
          if (!this.disabled) {
            this.showActions = true;
          }
        });

        this.renderer.listen(parent, 'mouseleave', (event) => {
          if (!this.disabled) {
            this.showActions = false;
          }
        });
      }

    }
  }

  ngDoCheck() {
    if (this.differ.diff(this.list)) {
      setOrderToList(this.list);
    }
  }

  //#endregion

  incleaseOrder() {
    if (this.isOrderAbleToInclease()) {
      this.item.Order += 1;
      this.afterChangeOrder();
    }
  }

  decleaseOrder() {
    if (this.isOrderAbleToDesclease()) {
      this.item.Order -= 1;
      this.afterChangeOrder();
    }
  }

  private afterChangeOrder() {
    orderPreviusList(this.item.Order, this.list);
    this.list = sortListByOrder(this.list, true);

    this.listChange.emit(this.list);
    this.orderChange.emit(this.item);
  }

  isOrderAbleToDesclease(): boolean {
    return !this.disabled && this.item.Order !== this.getMinOrder();
  }

  isOrderAbleToInclease(): boolean {
    const maxOrder = this.getMaxOrder();
    return !this.disabled && this.item.Order !== maxOrder;
  }

  getMinOrder(): number {
    let minOrder = 1;
    const countGroup = this.getLenthOfTheGroupColumns();

    if (!(this.item as Column).IsGroupBy && countGroup > 0) {
      minOrder = countGroup + 1;
    }

    return minOrder;
  }

  getMaxOrder(): number {
    let maxOrder = this.list.length;

    if ((this.item as Column).IsGroupBy) {
      maxOrder = this.getLenthOfTheGroupColumns();
    }

    return maxOrder;
  }

  getLenthOfTheGroupColumns() {
    return this.list.filter(x => (x as Column).IsGroupBy).length;
  }
}
